import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "box-waiting-time" }
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimeSelectorComponent = _resolveComponent("TimeSelectorComponent")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("small", null, _toDisplayString(_ctx.$t('AppResource.WaitingTime').toUpperCase()), 1),
    _hoisted_2,
    _createVNode(_component_TimeSelectorComponent, {
      modelValue: _ctx.actionToAdd.waitTime,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.actionToAdd.waitTime = $event)),
      "only-minute-seconds": true
    }, null, 8, ["modelValue"])
  ]))
}